import { combineReducers } from "redux"
import matchmakingUIReducer from "./matchmakingUIReducer"

export default combineReducers({
  ui: matchmakingUIReducer,
})
